import api from "../configurations/axios";
import WinnerDetailsResponse from '../responses/WinnerDetailsResponse'
import { GetWinnerRequest } from "../requests/GetWinnerRequest"

class WinnersService {
    async selectCompetitionWinner(
        competitionId: number,
        payload: GetWinnerRequest
    ): Promise<WinnerDetailsResponse> {
        try {
            const response = await api.post<WinnerDetailsResponse>(
                `api/winners/${competitionId}`,
                payload
            )

            return response.data
        } catch (error) {
            throw error
        }
    }
}

export default new WinnersService();